import { commons, inheritorDocs } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const HerdeiroCotasDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoHerdeiro: dynamicRule('required'),
    anexoDeclaracaoHerdeiros: dynamicRule('required'),
  };

  const docs = {
    commons: [...commons, ...inheritorDocs],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
